import { AfterViewInit, Component, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { BoxService } from '../box.service';

declare const Box: any;

@Component({
  selector: 'app-box-picker',
  templateUrl: './box.picker.component.html',
  styleUrls: ['./box.picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BoxPickerComponent implements AfterViewInit {
  @Input() folderId: string;
  @Input() options: any = {};

  constructor(
    private el: ElementRef,
    private boxService: BoxService,
  ) {}

  async ngAfterViewInit() {
    const filePicker = new Box.FilePicker();
    filePicker.on('cancel', () => {
      const message = { type: 'cancelPicker' };
      window.parent.postMessage(message, window.location.origin);
    });
    filePicker.on('choose', (data: any) => {
      const message = { type: 'selectedFiles', value: JSON.stringify(data) };
      window.parent.postMessage(message, window.location.origin);
    });
    filePicker.show(this.folderId, await this.boxService.getToken(), {
      container: this.el.nativeElement.querySelector('.viewer'),
      canCreateNewFolder: false,
      canUpload: false,
      canSetShareAccess: false,
      logoUrl: '',
      responseInterceptor: (response: any) => {
        const message = { type: 'numberOfFiles', value: response.data?.item_collection.entries.length };
        window.parent.postMessage(message, window.location.origin);
        return response;
      },
      ...this.options,
    });
  }
}
